import { useNavigate, useParams } from 'react-router-dom';
import { getLoginOtpURL, getRecoveryCodeURL } from '@hotjar/auth';
import { LOGIN } from '@hotjar/webapp/constants/routes/auth';
import { onTrackLogin } from '@hotjar/webapp/features/Login';
import { getNextURL } from './getNextURL';

export const useMFALogin = (): {
  mfaStateKey?: string;
  next: string;
  redirectToLogin: () => void;
  onLogin: () => void;
  onClickRecoveryCodes: () => void;
  onClickOtp: () => void;
} => {
  const { state: mfaStateKey } = useParams();
  const navigate = useNavigate();
  const next = getNextURL();

  const redirectToLogin = () => {
    navigate(LOGIN.path);
  };

  const onLogin = () => {
    onTrackLogin();
    window.location.assign(next);
  };

  const onClickRecoveryCodes = () => {
    if (!mfaStateKey) {
      return;
    }
    const url = getRecoveryCodeURL(mfaStateKey, next);
    navigate(`${url.pathname}${url.search}`);
  };

  const onClickOtp = () => {
    if (!mfaStateKey) {
      return;
    }
    const url = getLoginOtpURL(mfaStateKey, next);
    navigate(`${url.pathname}${url.search}`);
  };

  return {
    mfaStateKey,
    next,
    redirectToLogin,
    onLogin,
    onClickRecoveryCodes,
    onClickOtp,
  };
};
